let dt_index = null;
let content_type = '';

export function index(params){

    dt_index = $('#content_versions_table').DataTable({
        ajax: {
            url: $('#content_versions_table').attr('url'),
        },
        select: {
            style: 'multi+shift',
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_content_versions_actions },
            { width: '120', data: 'created_at', orderable: true, searchable: true, render: datatables.render_datetime },
            { data: 'author_id', orderable: true, searchable: true },
        ],
        order: [[1, 'desc']],
    });

    // dt_index.on('init', function(e, settings, json){
    //     $(settings.nTableWrapper).find('.table_batch_actions [action="delete_content_versions"]').click(batch_delete_content_versions);
    // });

    content_type = params.content_type;
}

function render_content_versions_actions(data, type, row){

    const url_info = ($("#content_versions_table").attr('url_info') ?? '').replace('#', row.id).replace('~', content_type);

    const actions = 
        '<div class="btn-group" role="group">' +
        '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('ver') + '</a>' +
        '</div>';

    return actions;

}


export function index_reload(){
    
    dt_index.ajax.reload();

}

export function index_force_reload(){

    dt_index.column(0).checkboxes.deselectAll();
    dt_index.ajax.reload();

}